<div class="ldngOvrlyCss">
  <div class="loading-indicator">
    @if (lgnPgData && lgnPgData.app_hdr_nm == 'CLAP' && clntDtls &&
    clntDtls[0].spr_admn_in!=1) {
    <div class="spinner-2">
      <img
        src="assets/images/logo/swatchAndraLgo.png"
        style="
          max-width: 150%;
          max-width: 215%;
          margin-left: -40%;
          margin-top: -36%;
          padding: 10%;
        "
      />
    </div>
    } @if (lgnPgData && lgnPgData.app_hdr_nm == 'WETRACKON' || (lgnPgData &&
    lgnPgData.app_hdr_nm == 'CLAP' && clntDtls && clntDtls[0].spr_admn_in==1) ||
    (lgnPgData && lgnPgData.app_hdr_nm == 'CDMA')) {
    <div class="spinner-2">
      <img
        src="assets/images/logo/icon.png"
        style="
          max-width: 150%;
          max-width: 215%;
          margin-left: -40%;
          margin-top: -36%;
          padding: 10%;
        "
      />
    </div>
    } @if (lgnPgData && lgnPgData.app_hdr_nm == 'APSFL' || (lgnPgData &&
    lgnPgData.app_hdr_nm == 'APSFL')) {
    <div class="spinner-2 apsfl">
      <img
        src="assets/images/apsfl_login_logo.png"
        style="
          max-width: 150%;
          max-width: 215%;
          margin-left: -40%;
          margin-top: -36%;
          padding: 10%;
        "
      />
    </div>
    }
  </div>
</div>
